import { AnalyticsObjectsChoose } from '../../widgets/analytics/analyticsObjectsChoose';
import ContentHeader from '../../widgets/contentHeader/ContentHeader';

// Страница выбора типов объектов для составления сводного отчёта
export function AnalyticsObjectsChoosePage() {

    return (
        <div className="analytics-objects-div">
            <ContentHeader title="Объекты для отчёта" />
            <AnalyticsObjectsChoose />
        </div>
    );
}

